import React from 'react';
import { AuthRoles } from "components/auth";

export const CustomersProvidersConfig = {
    auth: AuthRoles.admin,
    routes: [
        {
            path: `${process.env.PUBLIC_URL}/customers_providers`,
            component: React.lazy(() => import('./CustomersProviders'))
        }
    ]
};